import { render, staticRenderFns } from "./DefaultMetricNewPage.vue?vue&type=template&id=1e727302"
import script from "./DefaultMetricNewPage.vue?vue&type=script&lang=ts"
export * from "./DefaultMetricNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports